import React from 'react';
import { useStyles } from '../styles';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Slide,
  Typography,
} from "@material-ui/core";
import CurrencySymbol from './CurrencySymbol';
import { getPriceWithIncrease } from '../util';

export default function ProductList(props) {
  const styles = useStyles();
  let selCatId = props.selectedCat.id;
  let userData = props.userData;
  console.log(props.categories)
  let adOnCats = [];
  props.categories.filter(cat => cat.isAddOn && adOnCats.push(cat.id));
  console.log(adOnCats);
  return (
    <Grid container spacing={2} id="pro_continer" style={{ overflow: 'visible', height: 'auto' }}>
      {props.items?.filter(pro => (
        (!props.selectedCat && adOnCats.indexOf(pro.category) == -1)
        ||
        (pro.category == selCatId)) && pro.inStock).map(it => {
          const isCardView = userData?.OO_default_productView === 'cards';
          
          if (isCardView) {
            return (
              <Grid item key={it.id} xs={props.isLandscape ? 4 : 6} sm={props.isLandscape ? 3 : 6} md={props.isLandscape ? 3 : 4}>
                <Card
                  className={styles.card}
                  onClick={() => props.productClickHandler(it)}
                  style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "280px",
                    border: "1px solid " + userData.themeColor,
                    borderRadius: "15px",
                    background: userData.themeTxtColor,
                    color: userData.themeColor,
                    boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    overflow: 'hidden',
                    padding: "10px",
                    transition: 'transform 0.2s ease-in-out'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <CardMedia
                    component="img"
                    image={it.image}
                    className={styles.media}
                    onError={props.imageOnErrorHandler}
                    style={{ 
                      width: '100%', 
                      height: '30%', 
                      padding: "0px", 
                      borderRadius: '12px', 
                      objectFit: 'cover',
                      marginBottom: '10px'
                    }}
                  />
                  <CardContent style={{ padding: '8px!important', textAlign: 'center', width: '100%', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      gutterBottom
                      variant="h6"
                      style={{ 
                        fontSize: '1.15rem', 
                        fontWeight: 600, 
                        display: '-webkit-box', 
                        WebkitLineClamp: 2, 
                        WebkitBoxOrient: 'vertical', 
                        overflow: 'hidden', 
                        margin: '0px 0px 8px 0px',
                        color: userData.themeColor,
                        minHeight: '2.4em'
                      }}
                    >
                      {it.name}
                    </Typography>

                    <Typography
                      variant="body2"
                      style={{
                        fontSize: '0.85rem',
                        fontWeight: 'normal',
                        color: userData.themeColor,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        minHeight: '2.4em',
                        marginTop: '10px',
                        marginBottom: '10px'
                      }}
                    >
                      {it.description}
                    </Typography>

                    <Box style={{ marginTop: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                      <h3 style={{ margin: "0px", color: userData.themeColor, fontSize: '1.1rem', fontWeight: 700 }}>
                        <CurrencySymbol />
                        {(() => {
                          const increaseBy = it.onlineIncreaseBy || 0;
                          if (it.varietyPrices && it.varietyPrices !== '""' && it.varietyPrices !== '{}') {
                            try {
                              const varieties = JSON.parse(it.varietyPrices);
                              const prices = Object.values(varieties).map(p => {
                                const baseP = parseFloat(p);
                                return !isNaN(baseP) ? getPriceWithIncrease(baseP, increaseBy) : p;
                              });
                              if (prices.length > 0) return prices.join(' / ');
                            } catch (e) { console.error(e); }
                          }
                          const basePrice = it.weight_price || it.price || 0;
                          return basePrice ? getPriceWithIncrease(basePrice, increaseBy) : '?';
                        })()}
                      </h3>
                      <Button
                        variant="contained"
                        style={{
                          color: userData.themeTxtColor,
                          borderRadius: '50%',
                          fontWeight: '900',
                          fontSize: '1.4rem',
                          textTransform: 'none',
                          backgroundColor: userData.themeColor,
                          minWidth: '35px',
                          width: '35px',
                          height: '35px',
                          padding: '0',
                          lineHeight: '1',
                          boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          props.productClickHandler(it);
                        }}
                      >
                        +
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          }

          // Default List View
          return (<Grid item key={it.id} xs={props.isLandscape ? 6 : 12}>
            <Card
              className={styles.card}
              onClick={() => props.productClickHandler(it)}
              style={{
                width: "100%",
                height: "160px",
                border: "1px solid " + userData.themeColor,
                borderRadius: "15px",
                background: userData.themeTxtColor,
                color: userData.themeColor,
                boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                overflow: 'hidden',
                padding: "10px"
              }}
            >
              <CardMedia
                component="img"
                image={it.image}
                className={styles.media}
                onError={props.imageOnErrorHandler}
                style={{ 
                  width: props.isLandscape ? '140px' : '30%', 
                  height: props.isLandscape ? '140px' : '100%', 
                  padding: "0px", 
                  borderRadius: '12px', 
                  objectFit: 'contain',
                  flexShrink: 0
                }}
              />

              {false && it["cat_type"] ?
                <div className={styles.veg_img}>
                  <img
                    src={it.cat_type.toUpperCase() === "VEG" ? "/images/veg.png" : "/images/Non-veg.png"}
                    width="30px"
                    height="30px"
                  />
                </div> : " "
              }

              <CardContent className={styles.cardFooter} style={{ width: props.isLandscape ? 'calc(100% - 140px)' : '100%', padding: '12px!important', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', flexGrow: 1 }}>
                <Box className={styles.foot} style={{ textAlign: 'left', width: '100%', padding: '12px!important' }}>
                  <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                    <Typography
                      gutterBottom
                      className={styles.prod_title}
                      variant="h7"
                      component="p"
                      style={{ fontSize: '1.2rem', fontWeight: 600, display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden', margin: '0px', flex: 1, paddingRight: '10px' }}
                    >
                      {it.name}
                    </Typography>
                  </Box>

                  <Typography
                    variant="body2"
                    style={{
                      fontSize: '0.9rem',
                      fontWeight: 'normal',
                      color: userData.themeColor,
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      minHeight: '2.4em',
                      marginTop: '10px',
                      marginBottom: '8px'
                    }}
                  >
                    {it.description}
                  </Typography>

                  <Box style={{ marginTop: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <div className="pro_price" style={{ position: 'static', margin: '0px', textAlign: 'left', background: 'transparent', whiteSpace: 'nowrap' }}>
                      <h3 style={{ margin: "0px", color: userData.themeColor, fontSize: '1.1rem', fontWeight: 700 }}>
                        <CurrencySymbol />
                        {(() => {
                          const increaseBy = it.onlineIncreaseBy || 0;
                          if (it.varietyPrices && it.varietyPrices !== '""' && it.varietyPrices !== '{}') {
                            try {
                              const varieties = JSON.parse(it.varietyPrices);
                              const prices = Object.values(varieties).map(p => {
                                const baseP = parseFloat(p);
                                return !isNaN(baseP) ? getPriceWithIncrease(baseP, increaseBy) : p;
                              });
                              if (prices.length > 0) {
                                return prices.join(' / ');
                              }
                            } catch (e) {
                              console.error("Error parsing varietyPrices", e);
                            }
                          }
                          const basePrice = it.weight_price || it.price;
                          return basePrice ? getPriceWithIncrease(basePrice, increaseBy) : '?';
                        })()}
                      </h3>
                    </div>
                    <Button
                      variant="contained"
                      size="small"
                      style={{
                        margin: '2px',
                        color: userData.themeTxtColor,
                        borderRadius: '20px',
                        fontWeight: '900',
                        fontSize: '1.2rem',
                        textTransform: 'none',
                        backgroundColor: userData.themeColor,
                        width: 'fit-content',
                        padding: '0px 16px',
                        boxShadow: 'none'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        props.productClickHandler(it);
                      }}
                    >
                      +Add
                    </Button>
                  </Box>

                </Box>
              </CardContent>
            </Card>
          </Grid>
          )
        })}

    </Grid>
  );
}
